import { render, staticRenderFns } from "./TributeOnboardingSplash.vue?vue&type=template&id=d92affbc&scoped=true"
import script from "./TributeOnboardingSplash.vue?vue&type=script&lang=js"
export * from "./TributeOnboardingSplash.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d92affbc",
  null
  
)

export default component.exports